<template>
  <v-dialog
    hide-overlay
    :overlay-opacity="0"
    :transition="false"
    persistent
    ref="dialog"
    width="724px"
    :value="isOpen ? true : false"
    absolute
  >
    <div class="card-overlay" @click="$refs.dialog.animateClick()" />
    <v-card style="width: 724px" v-if="isOpen">
      <template
        v-if="selectedTheme !== undefined && Object.keys(selectedTheme).length && selectedTheme.screenshot_url"
      >
        <v-img
          height="285px"
          width="100%"
          position="top center"
          :src="selectedTheme.screenshot_url"
        />
        <v-divider />
      </template>
        <v-btn x-small icon @click="$emit('removeModal')" class="close-model">
          <v-icon>$close</v-icon>
        </v-btn>

        <v-form ref="form">
          <div
            v-if="!isCustomPrivilegesMenuOpen"
          >
            <v-card-title class="">
              <v-icon size="24" color="primary">$share2Icon</v-icon>
              <h6 class="ml-4 mb-0 font-weight-bold heading--text">
                {{ $t("reseller.modal.inviteUsers") }}
              </h6>
            </v-card-title>

            <v-card-text>
              <div
                class="invite-users-role"
                :class="
                  $vuetify.breakpoint.mdAndDown ? 'justify-end flex-wrap' : ''
                "
              >
                <div
                  class="d-flex flex-column w-100"
                  :style="
                    $vuetify.breakpoint.mdAndDown
                      ? ''
                      : 'max-width: calc(100% - 251px)'
                  "
                >
                  <label class="">{{
                    $t("form.label.user.choose")
                  }}</label>

                  <v-combobox
                    class="mb-0"
                    :placeholder="$t('form.placeholder.email')"
                    outlined
                    :items="userSuggestions"
                    :loading="userSuggestionsLoading"
                    :search-input.sync="userSuggestionsSearch"
                    v-model="userList"
                    multiple
                    append-icon="$close"
                    deletable-chips
                    chips
                    :filter="
                      (item, queryText) => {
                        return (
                          (item.email + item.name)
                            .toLocaleLowerCase()
                            .indexOf(queryText.toLocaleLowerCase()) > -1
                        );
                      }
                    "
                    hide-details=""
                    item-value="email"
                    item-text="name"
                    :menu-props="{
                      offsetY: true,
                      nudgeBottom: '8px',
                      closeOnContentClick: false,
                      contentClass:
                        'custom-dropdown-select custom-dropdown-select--autocomplete custom-dropdown-select--autocomplete-share',
                    }"
                  >
                    <template v-slot:selection="{ item }">
                      <v-chip
                        small
                        :class="isEmailCorrect(item) ? '' : 'v-chip--error'"
                      >
                        <span class="text-truncate">
                          {{ typeof item === "object" ? item.name : item }}
                        </span>
                        <v-icon
                          @click="chipRemove(item)"
                          v-ripple
                          size="16"
                          class="ml-1 delete-button"
                        >
                          $close
                        </v-icon>
                      </v-chip>
                    </template>
                    <template v-slot:append>
                      <v-icon size="16">$chevrondown</v-icon>
                    </template>
                    <template v-slot:item="{ item }">
                      <div class="d-flex align-center">
                        <v-avatar size="32px">
                          <v-img :src="getAvatarUrl(item.email, 32)" />
                        </v-avatar>
                        <div class="d-flex flex-column ml-3">
                          <p
                            class="s p-2 mb-0 font-weight-bold gray--text text--darken-2"
                          >
                            {{ item.name }}
                          </p>
                          <p
                            class="p-3 mb-0 mt-1"
                            v-if="item.name !== item.email"
                          >
                            {{ item.email }}
                          </p>
                        </div>
                      </div>
                    </template>
                  </v-combobox>
                </div>
                <div
                  class="d-flex align-center justify-end"
                  :class="[
                    $vuetify.breakpoint.width < 475
                      ? 'flex-column align-stretch'
                      : '',
                    $vuetify.breakpoint.mdAndDown ? 'w-100' : '',
                  ]"
                  style="max-width: 100%"
                  :style="$vuetify.breakpoint.width < 475 ? 'width: 100%' : ''"
                >
                  <div
                    class="d-flex flex-column"
                    :class="{
                      'w-100 ': $vuetify.breakpoint.width < 975,
                    }"
                  >
                    <label>{{
                      $t("form.label.role")
                    }}</label>

                    <select-dropdown
                      :style="
                        $vuetify.breakpoint.mdAndDown < 475
                          ? 'min-width: 100%;'
                          : 'min-width: 168px;'
                      "
                      :itemText="'text'"
                      :itemValue="'key'"
                      :items="roles"
                      :value="role"
                      class="combobox v-select--role-picker mb-0"
                      :placeholder="$t('form.placeholder.role')"
                      :block="$vuetify.breakpoint.width < 475"
                      @update:value="newRoleChanged"
                    />
                  </div>
                </div>
                <div
                  class="d-flex flex-column"
                  :class="{
                    'w-100 ': $vuetify.breakpoint.width < 975,
                  }"
                >                     
                  <v-btn
                    @click="assignUsers"
                    large
                    color="primary"
                    outlined
                    style="white-space: nowrap"
                    :style="$vuetify.breakpoint.width > 975 ? 'margin-top: 22px;' : ''"
                  >
                    {{ $t("button.sendInvite") }}
                  </v-btn>
                </div>
              </div>

              <div>
                <h6 class="">
                  {{ $t("heading.instance.modal.sharedAccess.table.title") }}
                </h6>
                <div class="d-flex flex-column">
                  <div
                    class="d-flex justify-space-between mt-3 font-weight-600"
                  >
                    <span class="p-5">
                      {{
                        $t("general.person", {
                          count: assignedUsers.length + 1,
                        })
                      }}
                    </span>
                    <div
                      style="width: 280px"
                      class="d-flex align-center justify-space-between mr-3"
                    >
                      <span class="p-5">{{ $t("table.header.role") }}</span>
                    </div>
                  </div>

                  <div class="user-list">
                    <InstanceShareItemOwner
                      :name="$store.state.home.user.name"
                      :email="$store.state.home.user.email"
                    />

                    <InstanceShareItem
                      v-for="(item, index) in assignedUsers"
                      :key="item.email + index"
                      :item="item"
                      :hasPendingChanges="false"
                      :roles="roles"
                      :mixedRoles="item.role == 'mixed'"
                      @role-changed="roleChanged"
                      @user-remove-access="unassignUser"
                      :resending="false"
                      :createShare="true"
                    />
                  </div>
                </div>
              </div>
            </v-card-text>
          </div>

          <ShareCustomPrivileges
            v-else
            :customPrivilegesUser="customPrivilegesUser"
            @save="saveCustomPrivileges"
            @cancel="closeCustomPrivilegesMenu"
          />
        </v-form>
      <template v-if="isImport">
        <v-card-actions class="pt-6 d-flex align-center justify-space-between">
          <div>
            <step-indicator :currentStep="3" :maxSteps="maxSteps" class="mr-3" />
          </div>
          <div class="d-flex align-center">
            <v-btn
              large
              @click="$emit('remove-modal')"
              text
              elevation="0"
              class="mr-3"
            >
              <span class="font-weight-bold gray--text text--darken-1">
                {{ $t("button.back") }}
              </span>
            </v-btn>
            <v-btn large @click="sharedAccessSet" color="primary" elevation="0">
              <span class="font-weight-bold">
                <span>{{ $t("button.continue") }}</span>
                <v-icon size="20" class="mr-0">$arrowright</v-icon>
              </span>
            </v-btn>
          </div>
        </v-card-actions>
      </template>
      <template v-else>
        <v-card-actions class="d-flex flex-column pb-4 px-10 pt-6">
          <v-btn
            x-large
            elevation="0"
            color="primary"
            block
            @click="sharedAccessSet"
            :loading="loading"
          >
            <template v-slot:loader>
              <v-progress-circular
                indeterminate
                size="20"
                width="2"
                class="mr-2"
              ></v-progress-circular>
              <span>{{ $t("button.domain.creating") }}</span>
            </template>

            <template v-if="hasSelectedServiceUserConfigurableOptions()">
              {{ $t(`button.set.${firstUserConfigurableOptionName}`) }}
              <v-icon size="24" class="ml-2">$arrowright</v-icon>
            </template>

            <template v-else-if="hasSelectedServiceAskForDomain()">
              {{ $t("button.domain.set") }}
              <v-icon size="24" class="ml-2">$arrowright</v-icon>
            </template>

            <template v-else-if="hasSelectedServiceAskForSiteName()">
              {{ $t("button.website.set") }}
              <v-icon size="24" class="ml-2">$arrowright</v-icon>
            </template>

            <template v-else>
              {{ $t("button.website.create") }}
              <v-icon size="24" class="ml-2">$arrowright</v-icon>
            </template>
          </v-btn>
          <v-btn
            v-if="services.length > 1"
            @click="$emit('change-service-button-clicked')"
            x-large
            elevation="0"
            class="mx-0 mt-2"
            color="gray"
            text
            block
          >
            <span class="font-weight-light gray--text text--darken-1">
              {{ $t("button.service.change") }}
            </span>
          </v-btn>
          <v-btn
            v-else-if="canSelectedServiceChooseTheme()"
            @click="$emit('change-theme-button-clicked')"
            x-large
            elevation="0"
            class="mx-0 mt-2"
            color="gray"
            text
            block
          >
            <span class="font-weight-light gray--text text--darken-1">
              {{ $t("button.theme.change") }}
            </span>
          </v-btn>
          <v-btn
            v-else
            @click="$emit('remove-modal')"
            x-large
            elevation="0"
            class="mx-0 mt-2"
            color="gray"
            text
            block
          >
            <span class="font-weight-light gray--text text--darken-1">
              {{ $t("button.cancel") }}
            </span>
          </v-btn>
        </v-card-actions>
      </template>
    </v-card>
  </v-dialog>
</template>

<script>
import FormRulesMixin from "../../mixins/FormRulesMixin";
import Api from "../../apis/Api";
import { getAvatarUrl } from "../../apis/HelperFunctions";
import StepIndicator from "../StepIndicator.vue";
import SelectDropdown from "../SelectDropdown.vue";
import InstanceShareItemOwner from "../instances/InstanceShareItemOwner.vue";
import InstanceShareItem from "../instances/InstanceShareItem.vue";
import ShareCustomPrivileges from "../modal/ShareCustomPrivileges.vue";
import OnboardingSelectedServiceMixin from "../../mixins/OnboardingSelectedServiceMixin";

export default {
  name: "OnboardingShareAccessModal",
  components: {
    StepIndicator,
    SelectDropdown,
    InstanceShareItemOwner,
    InstanceShareItem,
    ShareCustomPrivileges,
  },
  mixins: [FormRulesMixin, OnboardingSelectedServiceMixin],
  props: {
    selectedService: Object,
    selectedTheme: Object,
    services: Array,
    isOpen: [Boolean, String],
    loading: Boolean,
    isImport: Boolean,
    maxSteps: Number,
  },
  data() {
    return {
      getAvatarUrl,
      userSuggestions: [],
      userSuggestionsFetched: false,
      userSuggestionsLoading: false,
      userSuggestionsSearch: "",
      //
      isCustomPrivilegesMenuOpen: false,
      customPrivileges: [],
      customPrivilegesUser: null,
      role: "full_access",
      roles: [
        {
          text: "sharedAccess.role.viewOnly",
          key: "view_only",
          tooltip: this.$t("tooltip.instance.sharedAccess.role.viewOnly"),
        },
        {
          text: "sharedAccess.role.viewAndSso",
          key: "view_and_sso",
          tooltip: this.$t("tooltip.instance.sharedAccess.role.viewAndSso"),
        },
        {
          text: "sharedAccess.role.developer",
          key: "developer",
          tooltip: this.$t("tooltip.instance.sharedAccess.role.developer"),
        },
        {
          text: "sharedAccess.role.fullAccess",
          key: "full_access",
          tooltip: this.$t("tooltip.instance.sharedAccess.role.fullAccess"),
        },
        {
          text: "sharedAccess.role.custom",
          key: "custom",
          tooltip: this.$t("tooltip.instance.sharedAccess.role.custom"),
        },
      ],
      assignedUsers: [],
      userList: [],
    };
  },
  methods: {
    sharedAccessSet() {
      this.$emit("shared-access-set", this.assignedUsers);
    },
    isEmailCorrect: function (item) {
      if (typeof item === "object") {
        return this.validateEmail(item.email);
      } else {
        return this.validateEmail(item);
      }
    },
    validateEmail(email) {
      return /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(email);
    },
    //
    newRoleChanged(event) {
      this.role = event.key;
      if (event.key === "custom") {
        this.openCustomPrivilegesMenu();
      }
    },
    roleChanged(item, newValue) {
      item.role = newValue;
      if (newValue == "custom") {
        this.openCustomPrivilegesMenu(item);
      }
    },
    openCustomPrivilegesMenu(user = null) {
      if (user) {
        this.customPrivilegesUser = user;
      } else {
        this.customPrivileges = [];

        this.customPrivilegesUser = {
          role: "custom",
          customPrivileges: [],
        };
      }
      this.isCustomPrivilegesMenuOpen = true;
    },
    assignUsers() {
      for (let user of this.userList) {
        if (typeof user === "string") {
          user = { name: user, email: user };
        }
        if (this.assignedUsers.find((u) => u.email === user.email)) {
          continue;
        }
        if (this.assignedUsers.length > 0) {
          this.$store.dispatch("addAlert", {
            success: false,
            errorMessage: this.$t("Only one user can be initialy added."),
          });
          continue;
        }
        this.assignedUsers.push({
          name: user.name,
          email: user.email,
          role: this.role,
          customPrivileges: this.customPrivileges,
          invitationPending: false,
          invited_at_text: null,
          notification_sent_at_text: null,
          resend_available_at: null,
        });
      }
      this.userList = [];
    },
    unassignUser(user) {
      this.assignedUsers = this.assignedUsers.filter(
        (u) => u.email !== user.email
      );
    },
    saveCustomPrivileges() {
      if (!this.customPrivilegesUser.email) {
        this.customPrivileges = [...this.customPrivilegesUser.customPrivileges];
        this.customPrivilegesUser = null;
      }
      this.closeCustomPrivilegesMenu();
    },
    closeCustomPrivilegesMenu() {
      this.isCustomPrivilegesMenuOpen = false;
      this.customPrivilegesUser = null;
    },
  },
  watch: {
    isOpen: function (open) {
      if (open) {
        this.$store.dispatch("lockBodyScroll");
      }
      this.$store.dispatch("unlockBodyScroll");
    },
    userSuggestionsSearch() {
      if (this.userSuggestionsFetched) {
        return;
      }
      this.userSuggestionsFetched = true;
      this.userSuggestionsLoading = true;
      Api.get("/invitation-suggestions")
        .then((response) => {
          this.userSuggestions = response.data.data;
        })
        .catch((error) => {
          this.$store.dispatch("addAlert", {
            success: false,
            errorMessage: Api.getErrorMessage(error),
          });
        })
        .finally(() => {
          this.userSuggestionsLoading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.v-card {
  .v-card__text {
    -webkit-line-clamp: none;
    -webkit-box-orient: vertical;
    color: var(--v-gray-lighten1);
  }

  @media (max-width: 975px) {
    .v-card__text {
      padding: 0 24px !important;
    }

    .v-card__title {
      padding: 24px !important;
    }

    .v-card__actions {
      padding: 24px 24px 12px 24px !important;
    }

    .combobox {
      width: 100%;
      flex-grow: 1;
    }
  }
}

.v-expansion-panel::v-deep {
  &:not(:last-child) {
    margin-bottom: 32px;
  }

  &::before,
  &::after {
    display: none;
  }

  .v-expansion-panel-content {
    &__wrap {
      padding-bottom: 0px;
      padding-top: 32px;

      > div:not(:last-child) {
        margin-bottom: 16px;
      }
    }

    .checkbox {
      label {
        margin-left: 12px;
        color: var(--v-gray-darken2);
        font-size: $font-size-base;
        line-height: $line-height-base;
        font-weight: $font-weight-light;
      }

      &--error-label {
        label {
          font-weight: $font-weight-bold;
          color: var(--v-error-base);
        }
      }

      &--info-label {
        label {
          font-weight: $font-weight-bold;
          color: var(--v-info-base);
        }
      }
    }
  }

  .v-expansion-panel-header {
    padding: 0;
    min-height: unset;
    background: transparent !important;

    .chevron {
      color: var(--v-gray-lighten1);
    }

    &--active {
      .chevron {
        color: var(--v-primary-base) !important;
        transform: rotate(180deg);
        transition: color 0.24s ease, transform 0.24s ease;
      }
    }

    &:hover {
      background: transparent !important;
    }

    & > *:not(.v-expansion-panel-header__icon) {
      flex: 0 1 auto;
    }
  }
}

.v-autocomplete::v-deep {
  .v-chip {
    background: transparent;
    border: 1px solid var(--v-gray-lighten3);
    border-radius: 5px;
    color: var(--v-gray-darken2);
    padding: 4px;
    font-size: $font-size-sm;
    line-height: $line-height-sm;
    font-weight: $font-weight-normal;
    height: 28px;
    // max-width: calc(100% - 32px);
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;

    .v-chip__content {
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }

    .delete-button {
      color: var(--v-gray-darken1);
    }

    &.v-chip--error {
      border: 1px solid var(--v-error-base);
      color: var(--v-error-base);

      .delete-button {
        color: var(--v-error-base);
      }
    }
  }

  .v-input__append-inner {
    padding-left: 0px !important;
  }

  .v-input__control .v-input__slot {
    max-height: unset !important;
    height: fit-content;

    .v-select__selections {
      min-height: unset;
      padding: 0;

      input {
        min-width: 126px;
        max-width: unset;
        max-height: unset;
      }
    }
  }

  .v-select__selections {
    padding: 0px 0 !important;
  }

  input {
    padding: 0px !important;
  }

  &.v-select--is-menu-active {
    .v-input__append-inner {
      .v-icon {
        color: map-get($primary, darken1) !important;
        transform-origin: center;
        transform: rotate(180deg);
      }
    }
  }
}

.checkbox::v-deep {
  margin-right: 12px;

  .v-input.v-input--checkbox .v-input__control .v-input__slot {
    min-height: unset;
  }
}

.input-dropdown::v-deep {
  .v-select__selections .v-select__selection {
    font-size: $font-size-base;
    line-height: $line-height-base;
    font-weight: $font-weight-light;
    color: var(--v-text-base);
    margin: 0px;
  }
}

.user-list {
  display: flex;
  flex-direction: column;
  max-height: 260px;
  overflow-y: auto !important;
  margin-left: -8px;

  &::-webkit-scrollbar {
    width: 14px;
  }

  &::-webkit-scrollbar-track {
    box-shadow: none;
    background-color: transparent;
    max-width: 8px;
    border: 3px solid transparent;
  }

  &::-webkit-scrollbar-thumb {
    background-color: var(--v-gray-lighten2);
    border-radius: 8px;
    border: 4px solid transparent;
    background-clip: padding-box;
  }
}

.v-avatar {
  border-color: var(--v-gray-lighten2) !important;
  border-style: solid !important;
  border-width: 1px !important;
}

.none-option {
  color: #757575;
  font-style: italic;
}

.invite-users-role{
  display: flex;
  align-items: flex-start;
  margin-bottom: 24px;
  gap: 16px;
}
</style>